import type { AuthChangeEvent, Session, SignInWithPasswordCredentials, SignUpWithPasswordCredentials } from '@supabase/supabase-js'

import { createClient } from '@supabase/supabase-js'


let _supabaseClient: ReturnType<typeof createClient>

function getSupabaseClient() {
  if (_supabaseClient === undefined) {
    const supabaseUrl = process.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL
    const supabaseKey = process.env.SUPABASE_SERVICE_ROLE_KEY || process.env.VITE_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY
    if (!supabaseUrl || !supabaseKey) {
      throw new Error('Missing Supabase environment variables')
    }
    _supabaseClient = createClient(supabaseUrl, supabaseKey, {
      auth: {
        throwOnError: true,
      }
    })
  }
  return _supabaseClient
}

export const authClient = {
  useFake: null as (Session | null),
  async getSession() {
    if (this.useFake) {
      return this.useFake
    }
    return (await getSupabaseClient().auth.getSession()).data.session
  },
  getUser: (jwt: string) => {
    return getSupabaseClient().auth.getUser(jwt)
  },
  onAuthStateChange(callback: (event: AuthChangeEvent, session: Session | null) => void) {
    if (this.useFake) {
      return
    }
    return getSupabaseClient().auth.onAuthStateChange(callback)
  },
  signUp: (credentials: SignUpWithPasswordCredentials) => {
    return getSupabaseClient().auth.signUp(credentials)
  },
  signInWithPassword: (credentials: SignInWithPasswordCredentials) => {
    return getSupabaseClient().auth.signInWithPassword(credentials)
  },
  signOut: () => {
    return getSupabaseClient().auth.signOut()
  }
}